module.exports = __webpack_public_path__ + "static/media/smp.9bcd465c.svg";